(function () {
  class BackgroundLightningDisplay extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleIntroEvent', this.onShuffleIntroEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleEndEvent', this.onShuffleEndEvent.bind(this));
      messageBus.subscribe('persistence:stakeChanged', this.onPersistenceStakeChanged.bind(this));
      messageBus.subscribe('sidewinder:PowerBarAdjustEvent', this.onPowerBarAdjust.bind(this));
      messageBus.subscribe('sidewinder:xtraPowerRedBackground', this.onXtraPowerRedBackground.bind(this));
      messageBus.subscribe('sidewinder:XtraPowerTriggerEvent', this.onXtraPowerTriggerEvent.bind(this));

      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));
    }

    initialise() {
      this._jsonPath = this.name;
      this._centrePos = { x: 642, y: 315 };
      this._backgroundSpine = undefined;
      this._backgroundSpineRed = undefined;
      this._backgroundGlowsMain = undefined;
      this._backgroundGlowsFeature = undefined;
      this._redStars = undefined;
      this._starEmitterCount = 10;
      this._backgroundStarEmitters = [];
      this._backgroundStarted = false;
      this._currentLevel = 0;
      this._spotlightRotationAnim = undefined;
      this._currentBackgroundState = undefined;
      this._shuffleIntroEventTask = undefined;
      this._powerBarLevel = 0;
      this._enabled = false;
      this._currentMode = 'default';
    }

    update(delta, time) {
      if (this._backgroundStarted) {
        this.updateStars();
      }
    }

    onGameConfigEvent() {
      const backgroundContainer = this.name + ':backgroundLightningContainer';

      this._spotlight = resourceManager.createObject('sprite', 'spotlight', backgroundContainer, {
        fileName: 'particles/BW_Rays.png',
        anchor: 0.5,
        x: this._centrePos.x,
        y: this._centrePos.y,
        scale: 2.5,
      });
      this._spotlight.alpha = 0.5;
      this._spotlight.blendMode = PIXI.BLEND_MODES.ADD;
      this._spotlight.visible = false;

      this._backgroundSpine = resourceManager.createObject('spine', 'BackgroundSpine', backgroundContainer, {
        name: 'BKG_Electric',
        x: this._centrePos.x,
        y: this._centrePos.y,
        anchor: 0.5,
        scaleX: 1,
        scaleY: 1,
      });
      this._backgroundSpine.blendMode = PIXI.BLEND_MODES.ADD;
      this._backgroundSpine.visible = false;

      this._backgroundRedSpine = resourceManager.createObject('spine', 'BackgroundRedSpine', backgroundContainer, {
        name: 'BKG_Electric_Red',
        x: this._centrePos.x,
        y: this._centrePos.y,
        anchor: 0.5,
        scaleX: 1,
        scaleY: 1,
      });
      this._backgroundRedSpine.blendMode = PIXI.BLEND_MODES.ADD;
      this._backgroundRedSpine.visible = false;

      this._backgroundGlowsMain = particleManager.createEmitter('backgroundGlows', backgroundContainer, 0, 0, false);
      this._backgroundGlowsMain.particleEmitter.blendMode = PIXI.BLEND_MODES.ADD;
      this._backgroundGlowsMain.particleEmitter.emit = false;
      this._backgroundGlowsMain.visible = false;

      this._backgroundGlowsFeature = particleManager.createEmitter(
        'backgroundGlowsFeature',
        backgroundContainer,
        0,
        0,
        false
      );
      this._backgroundGlowsFeature.particleEmitter.blendMode = PIXI.BLEND_MODES.ADD;
      this._backgroundGlowsFeature.particleEmitter.emit = false;
      this._backgroundGlowsFeature.visible = false;

      for (let i = 0; i < this._starEmitterCount; i++) {
        const star = particleManager.createEmitter('backgroundStars', backgroundContainer, 0, 0, false);
        star.particleEmitter.particleBlendMode = PIXI.BLEND_MODES.ADD;
        star.particleEmitter.emit = false;
        star.visible = false;

        const starData = {
          particle: star,
          active: false,
          available: true,
        };
        this._backgroundStarEmitters.push(starData);
      }

      this._redStars = particleManager.createEmitter(
        'redStars',
        backgroundContainer,
        this._centrePos.x,
        this._centrePos.y,
        false
      );
      this._redStars.particleEmitter.particleBlendMode = PIXI.BLEND_MODES.ADD;
      this._redStars.particleEmitter.emit = false;
      this._redStars.visible = false;

      this._backgroundImages = {
        default: {
          landscape: resourceManager.get('backgroundContainer'),
          portrait: resourceManager.get('backgroundContainerPortrait'),
        },
        shuffle: {
          landscape: resourceManager.get('shuffleBackgroundContainer'),
          portrait: resourceManager.get('shuffleBackgroundContainerPortrait'),
        },
        xtraPower: {
          landscape: resourceManager.get('xtraPowerBackgroundContainer'),
          portrait: resourceManager.get('xtraPowerBackgroundContainerPortrait'),
        },
      };
      const stakeController = resourceManager.getController('stakeController');
      const isXtra = persistence.getData(stakeController.CurrentStake);
      this.setBackgroundImage('default');
    }

    onShuffleIntroEvent(task) {
      const self = this;

      this._shuffleIntroEventTask = task;
      this._shuffleIntroEventTask.join();

      timerManager.addTimer(1500, undefined, function () {
        const xtraPowerFeature = task.data.xtraPowerFeature;
        if (xtraPowerFeature) {
          musicManager.onXtraPowerStart();
          self.setBackgroundImage('xtraPower', 1.0);
          self.setLightningLevel(6);
        } else {
          musicManager.onShuffleStart();
          self.setBackgroundImage('shuffle', 1.0);
          self.incrementLevel();
        }
      });
    }

    onShuffleEndEvent(task) {
      this.setBackgroundImage('default', 1.0);
      this._powerBarLevel = persistence.getData(resourceManager.getController('stakeController').CurrentStake).x.x.p;
      this.checkForLevelChange(this._powerBarLevel);
    }

    onPersistenceStakeChanged(data) {
      this._powerBarLevel = data.data.x.x.p;
      this.setBackgroundImage('default');
      this.checkForLevelChange(this._powerBarLevel, gdk.getServerParser()._restoringPreviousWager);
    }

    onPowerBarAdjust(task) {
      this._powerBarLevel = task.data.xPowerBar.finalBarPower;
    }

    onXtraPowerTriggerEvent(task) {
      this._enabled = true;
      this.onXtraPowerRedBackground({ enabled: true, time: 1.0 });
    }

    onXtraPowerRedBackground(data) {
      this._enabled = data.enabled;
      if (data.enabled) {
        this.showBackgroundRedStars(true);
        const tween = gsap.to(this._backgroundGlowsMain, {
          pixi: { alpha: 0 },
          duration: 0.2,
          ease: 'linear',
          onComplete: () => {
            this._backgroundGlowsMain.visible = false;
            this._backgroundGlowsMain.alpha = 1;
            this._backgroundGlowsMain.particleEmitter.emit = false;
          },
        });
        if (!data.time) {
          tween.progress(1);
        }
      } else {
        const tween = gsap.to([this._redStars, this._backgroundGlowsFeature], {
          pixi: { alpha: 0 },
          duration: 0.2,
          ease: 'linear',
          onComplete: () => {
            this.showBackgroundRedStars(false);
            this._redStars.alpha = 1;
            this._backgroundGlowsFeature.alpha = 1;
          },
        });
        if (!data.time) {
          tween.progress(1);
        }
        this._backgroundGlowsMain.particleEmitter.emit = true;
        this._backgroundGlowsMain.visible = true;
      }
    }

    startBackground() {
      this._backgroundGlowsMain.particleEmitter.emit = true;
      this._backgroundGlowsMain.visible = true;
      this._backgroundStarted = true;
      this.setLightningLevel(this._currentLevel);
      this.setBackgroundImage(this._currentMode);
    }

    setLightningLevel(level, instant = false) {
      let backgroundSpine = this._enabled ? this._backgroundRedSpine : this._backgroundSpine;

      let levelUpgrade = false;

      if (level === this._currentLevel) {
        return;
      } else if (level > this._currentLevel) {
        levelUpgrade = true;
      }
      let blueBackgroundTween;
      let redBackgroundTween;
      if (level > 0 && level <= 6) {
        if (this._enabled) {
          if (!this._backgroundRedSpine.visible) {
            blueBackgroundTween = gsap.to(this._backgroundSpine, {
              pixi: { alpha: 0 },
              duration: 0.2,
              ease: 'linear',
              onComplete: () => {
                this._backgroundSpine.visible = false;
                this._backgroundSpine.alpha = 1;
                this._backgroundSpine.stop();
              },
            });
            this._backgroundRedSpine.alpha = 0;
            this._backgroundRedSpine.visible = true;
            redBackgroundTween = gsap.to(this._backgroundRedSpine, {
              pixi: { alpha: 1 },
              duration: 0.2,
              ease: 'linear',
            });
          } else {
            this._backgroundRedSpine.visible = false;
            this._backgroundRedSpine.alpha = 1;
            this._backgroundRedSpine.stop();
            backgroundSpine = this._backgroundSpine;
          }
        } else if (!this._enabled && this._backgroundRedSpine.visible) {
          redBackgroundTween = gsap.to(this._backgroundRedSpine, {
            pixi: { alpha: 0 },
            duration: 0.2,
            ease: 'linear',
            onComplete: () => {
              this._backgroundRedSpine.visible = false;
              this._backgroundRedSpine.alpha = 1;
              this._backgroundRedSpine.stop();
            },
          });
          this._backgroundSpine.alpha = 0;
          this._backgroundSpine.visible = true;
          blueBackgroundTween = gsap.to(this._backgroundSpine, {
            pixi: { alpha: 1 },
            duration: 0.2,
            ease: 'linear',
          });
        }

        if (level === 1) {
          backgroundSpine.play('Level1', true, 0, undefined);
          if (levelUpgrade) {
            this.pulseSpotlight(0.2, 0.3, 0.2);
          }
        } else if (level === 2) {
          backgroundSpine.play('Level2', true, 0, undefined);
          if (levelUpgrade) {
            this.pulseSpotlight(0.2, 0.5, 0.2);
          }
        } else if (level === 3) {
          backgroundSpine.play('Level3', true, 0, undefined);
          if (levelUpgrade) {
            this.pulseSpotlight(0.2, 0.75, 0.2);
          }
        } else if (level === 4) {
          backgroundSpine.play('Level4', true, 0, undefined);
          if (levelUpgrade) {
            this.pulseSpotlight(0.2, 1.0, 0.2);
          }
        } else if (level === 5) {
          backgroundSpine.play('Level4', true, 0, undefined);
          this.turnOnSpotlight(0.2);
        } else if (level === 6) {
          backgroundSpine.play('Level4', true, 0, undefined);
          this.turnOnSpotlight(0.2);
        }
        if (level < 5) {
          if (this._spotlightRotationAnim) {
            this.turnOffSpotlight(0.2);
          }
        }
        backgroundSpine.visible = true;
      } else {
        blueBackgroundTween = gsap.to([this._backgroundSpine, this._backgroundRedSpine], {
          pixi: { alpha: 0 },
          duration: 0.2,
          ease: 'linear',
          onComplete: () => {
            this._backgroundSpine.visible = false;
            this._backgroundSpine.alpha = 1;
            this._backgroundSpine.stop();

            this._backgroundRedSpine.visible = false;
            this._backgroundRedSpine.alpha = 1;
            this._backgroundRedSpine.stop();
          },
        });

        if (this._spotlightRotationAnim) {
          this.turnOffSpotlight(0.2, instant);
        }
      }
      if (instant && blueBackgroundTween) {
        blueBackgroundTween.progress(1);
      }
      if (instant && redBackgroundTween) {
        redBackgroundTween.progress(1);
      }
      this._currentLevel = level;
    }

    turnOnSpotlight(fadeIn) {
      if (this._spotlightRotationAnim) {
        this._spotlightRotationAnim.kill();
        this._spotlightRotationAnim = undefined;
      }

      this._spotlight.rotation = 0;
      this._spotlightRotationAnim = gsap.to(this._spotlight, {
        duration: 5,
        rotation: Math.PI * 2,
        repeat: -1,
        ease: 'none',
      });

      this._spotlight.alpha = 0;
      this._spotlight.visible = true;

      this._spotlightFadeInTween = gsap.to(this._spotlight, {
        duration: fadeIn,
        ease: 'linear',
        alpha: 0.5,
        onComplete: () => {
          this._spotlight.alpha = 0.5;
        },
      });
    }

    turnOffSpotlight(fadeOut, instant = false) {
      if (this._spotlightFadeInTween.isActive()) {
        this._spotlightFadeInTween.progress(1);
      }
      const tween = gsap.to(this._spotlight, {
        duration: fadeOut,
        ease: 'linear',
        alpha: 0,
        onComplete: () => {
          this._spotlight.visible = false;
          this._spotlight.alpha = 0.5;
          if (this._spotlightRotationAnim) {
            this._spotlightRotationAnim.kill();
            this._spotlightRotationAnim = undefined;
          }
        },
      });
      if (instant) {
        tween.progress(1);
      }
    }
    pulseSpotlight(fadeIn, duration, fadeOut) {
      this.turnOnSpotlight(fadeIn);

      const completeTime = (fadeIn + duration) * 1000;
      const self = this;
      timerManager.addTimeout(completeTime, function () {
        self.turnOffSpotlight(fadeOut);
      });
    }

    incrementLevel() {
      // I know there is technically an additional level...
      // ... but this is reserved for xtra power feature
      if (this._currentLevel < 5) {
        this.setLightningLevel(this._currentLevel + 1);
      }
    }

    updateStars() {
      for (let i = 0; i < this._starEmitterCount; i++) {
        const star = this._backgroundStarEmitters[i];

        if (star.available && !star.active) {
          let finalPos = {};
          let direction = this.getRandom(4);
          if (direction === 0) {
            // Up
            finalPos.x = this.getRandom(1400);
            finalPos.y = -120;
          } else if (direction === 1) {
            // Down
            finalPos.x = this.getRandom(1400);
            finalPos.y = 1400;
          } else if (direction === 2) {
            // Left
            finalPos.x = -120;
            finalPos.y = this.getRandom(1400);
          } else {
            // Right
            finalPos.x = 1400;
            finalPos.y = this.getRandom(1400);
          }
          star.active = true;

          let emitterSpawnPos = {
            x: this._centrePos.x,
            y: this._centrePos.y,
          };
          star.particle.particleEmitter.updateOwnerPos(emitterSpawnPos.x, emitterSpawnPos.y);

          gsap.to(emitterSpawnPos, {
            delay: this.getRandomFloat(0.5, 2.0),
            duration: 0.5,
            ease: 'linear',
            x: finalPos.x,
            y: finalPos.y,
            onStart: () => {
              star.particle.particleEmitter.emit = true;
              star.particle.visible = true;
            },
            onUpdate: () => {
              star.particle.particleEmitter.updateOwnerPos(emitterSpawnPos.x, emitterSpawnPos.y);
            },
            onComplete: () => {
              star.particle.particleEmitter.emit = false;
              star.particle.visible = false;
              star.active = false;
            },
          });
        }
      }
    }

    setBackgroundImage(mode, time) {
      this._currentMode = mode;

      // If time is undefined, just set the background to what is supplied for
      // quick changes, i.e. loading, but we don't want to be doing fades
      // if we're already on the correct background
      const layout =
        layoutController.getCurrentLayout() === 'landscape_default' ||
        layoutController.getCurrentLayout() === 'landscape_mobile'
          ? 'landscape'
          : 'portrait';
      const stakeController = resourceManager.getController('stakeController');
      const isXtra = persistence.getData(stakeController.CurrentStake).x.x.p === 100 || mode === 'xtraPower';

      messageBus.postImmediate('sidewinder:xtraPowerRedBackground', { enabled: isXtra, time: time });

      if (time === undefined) {
        Object.entries(this._backgroundImages).forEach(([modeKey, layouts]) => {
          Object.entries(layouts).forEach(([layoutKey, background]) => {
            background.visible = modeKey === mode && layoutKey === layout;
          });
        });
        this._currentBackgroundState = mode;
      } else if (mode !== this._currentBackgroundState) {
        const newBackground = Object.values(this._backgroundImages[mode]);
        const oldBackgrounds = Object.values(this._backgroundImages[this._currentBackgroundState]);

        newBackground.forEach((background, i) => {
          background.alpha = 0;
          background.visible = true;

          gsap.to(background, {
            duration: time,
            ease: 'linear',
            alpha: 1,
            onComplete: () => {
              background.alpha = 1;
            },
          });

          const oldBackground = oldBackgrounds[i];

          gsap.to(oldBackground, {
            duration: time,
            ease: 'linear',
            alpha: 0,
            onComplete: () => {
              oldBackground.visible = false;
              oldBackground.alpha = 1;

              if (i === oldBackgrounds.length - 1) {
                this.screenBackgroundChangeComplete(mode);
              }
            },
          });
        });
      }
    }

    showBackgroundRedStars(show) {
      this._redStars.visible = show;
      this._redStars.particleEmitter.emit = show;
      this._backgroundGlowsFeature.visible = show;
      this._backgroundGlowsFeature.particleEmitter.emit = show;
    }

    screenBackgroundChangeComplete(mode) {
      if (this._shuffleIntroEventTask) {
        this._shuffleIntroEventTask.leave();
        this._shuffleIntroEventTask = undefined;
      }
      this._currentBackgroundState = mode;
    }

    checkForLevelChange(powerLevel, instant = false) {
      console.log('power level =', powerLevel);
      if (powerLevel >= 90) {
        this.setLightningLevel(5, instant);
      } else if (powerLevel >= 75) {
        this.setLightningLevel(4, instant);
      } else if (powerLevel >= 50) {
        this.setLightningLevel(3, instant);
      } else if (powerLevel >= 25) {
        this.setLightningLevel(2, instant);
      } else if (powerLevel > 10) {
        this.setLightningLevel(1, instant);
      } else {
        this.setLightningLevel(0, instant);
      }
    }

    getRandom = function (size) {
      return Math.floor(Math.random() * size);
    };

    getRandomFloat = function (min, max) {
      return Math.random() * (max + Number.EPSILON - min) + min;
    };

    onLayoutChange() {
      if (this._backgroundStarted) {
        this.setBackgroundImage(this._currentMode);
      }
    }
  }

  let creator = function (json) {
    return new BackgroundLightningDisplay();
  };

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('backgroundLightningDisplay', creator, initialise, filesRequired);
})();
